import { createAction, props } from '@ngrx/store';
import { getActionName } from '@app/core/state/state-helpers';
import { MonthEndStepTemplate } from '../models/month-end-step-template';
import { MonthEndProcessState } from '../models/month-end-process-state';
import { MonthEndTaskValue } from '../models/month-end-task-value';
import { ActiveUser } from '../models/active-user';

export const monthEndActionPrefix = '[Month End Process]';

export const connectToMonthEndSignalRHub = createAction(
  getActionName('Connect To Month End SignalR Hub', monthEndActionPrefix),
);

export const connectToMonthEndSignalRHubSuccess = createAction(
  getActionName(
    'Connect To Month End SignalR Hub Success',
    monthEndActionPrefix,
  ),
);

export const connectToMonthEndSignalRHubFailure = createAction(
  getActionName(
    'Connect To Month End SignalR Hub Failure',
    monthEndActionPrefix,
  ),
  props<{ error: string }>(),
);

export const disconnectFromMonthEndSignalRHub = createAction(
  getActionName('Disconnect From Month End SignalR Hub', monthEndActionPrefix),
);

export const signalRConnectionLost = createAction(
  getActionName('SignalR Connection Lost', monthEndActionPrefix),
);

export const loadMonthEndTemplates = createAction(
  getActionName('Load Month End Templates', monthEndActionPrefix),
  props<{ glPeriod: number }>(),
);

export const loadMonthEndTemplatesSuccess = createAction(
  getActionName('Load Month End Templates Success', monthEndActionPrefix),
  props<{ stepTemplates: MonthEndStepTemplate[] }>(),
);

export const loadMonthEndTemplatesFailure = createAction(
  getActionName('Load Month End Templates Failure', monthEndActionPrefix),
  props<{ error: string }>(),
);

export const loadCurrentGlPeriod = createAction(
  getActionName('Load Current GL Period', monthEndActionPrefix),
);

export const loadCurrentGlPeriodSuccess = createAction(
  getActionName('Load Current GL Period Success', monthEndActionPrefix),
  props<{ currentGlPeriod: number }>(),
);

export const loadCurrentGlPeriodFailure = createAction(
  getActionName('Load Current GL Period Failure', monthEndActionPrefix),
  props<{ error: string }>(),
);

export const loadActiveMonthEndProcess = createAction(
  getActionName('Load Active Month End Process', monthEndActionPrefix),
);

export const loadActiveMonthEndProcessSuccess = createAction(
  getActionName('Load Active Month End Process Success', monthEndActionPrefix),
  props<{
    processState: MonthEndProcessState | null;
    currentGlPeriod: number;
  }>(),
);

export const loadActiveMonthEndProcessFailure = createAction(
  getActionName('Load Active Month End Process Failure', monthEndActionPrefix),
  props<{ error: string }>(),
);

export const loadActiveUsers = createAction(
  getActionName('Load Active Users', monthEndActionPrefix),
);

export const loadActiveUsersSuccess = createAction(
  getActionName('Load Active Users Success', monthEndActionPrefix),
  props<{ users: ActiveUser[] }>(),
);

export const loadActiveUsersFailure = createAction(
  getActionName('Load Active Users Failure', monthEndActionPrefix),
  props<{ error: string }>(),
);

export const toggleMultipleUserLockStatus = createAction(
  getActionName('Toggle Multiple User Lock Status', monthEndActionPrefix),
  props<{ userIds: number[] }>(),
);

export const toggleMultipleUserLockStatusSuccess = createAction(
  getActionName(
    'Toggle Multiple User Lock Status Success',
    monthEndActionPrefix,
  ),
);

export const toggleMultipleUserLockStatusFailure = createAction(
  getActionName(
    'Toggle Multiple User Lock Status Failure',
    monthEndActionPrefix,
  ),
  props<{ error: string }>(),
);

export const loadProcessStateByGlPeriod = createAction(
  getActionName('Load Process State By GL Period', monthEndActionPrefix),
  props<{ glPeriod: number }>(),
);

export const loadProcessStateByGlPeriodSuccess = createAction(
  getActionName(
    'Load Process State By GL Period Success',
    monthEndActionPrefix,
  ),
  props<{ processState: MonthEndProcessState | null; glPeriod: number }>(),
);

export const loadProcessStateByGlPeriodFailure = createAction(
  getActionName(
    'Load Process State By GL Period Failure',
    monthEndActionPrefix,
  ),
  props<{ error: string }>(),
);

export const receiveProcessStateUpdate = createAction(
  getActionName(
    'Receive Process State Update From SignalR',
    monthEndActionPrefix,
  ),
  props<{ processState: MonthEndProcessState }>(),
);

export const startMonthEndProcess = createAction(
  getActionName('Start Month End Process', monthEndActionPrefix),
);

export const startMonthEndProcessSuccess = createAction(
  getActionName('Start Month End Process Success', monthEndActionPrefix),
);

export const startMonthEndProcessFailure = createAction(
  getActionName('Start Month End Process Failure', monthEndActionPrefix),
  props<{ error: string }>(),
);

export const proceedStep = createAction(
  getActionName('Proceed Step', monthEndActionPrefix),
  props<{ processId: number; taskValue: MonthEndTaskValue }>(),
);

export const proceedStepSuccess = createAction(
  getActionName('Proceed Step Success', monthEndActionPrefix),
);

export const proceedStepFailure = createAction(
  getActionName('Proceed Step Failure', monthEndActionPrefix),
  props<{ error: string }>(),
);

export const retryStep = createAction(
  getActionName('Retry Step', monthEndActionPrefix),
  props<{ processId: number; taskId: number }>(),
);

export const retryStepSuccess = createAction(
  getActionName('Retry Step Success', monthEndActionPrefix),
);

export const retryStepFailure = createAction(
  getActionName('Retry Step Failure', monthEndActionPrefix),
  props<{ error: string }>(),
);

export const completeMonthEndProcess = createAction(
  getActionName('Complete Month End Process', monthEndActionPrefix),
  props<{ processId: number }>(),
);

export const completeMonthEndProcessSuccess = createAction(
  getActionName('Complete Month End Process Success', monthEndActionPrefix),
);

export const completeMonthEndProcessFailure = createAction(
  getActionName('Complete Month End Process Failure', monthEndActionPrefix),
  props<{ error: string }>(),
);

export const loadStartEligibility = createAction(
  getActionName('Load Start Eligibility', monthEndActionPrefix),
);

export const loadStartEligibilitySuccess = createAction(
  getActionName('Load Start Eligibility Success', monthEndActionPrefix),
  props<{
    canStartToday: boolean;
    earliestRunDate: string;
  }>(),
);

export const loadStartEligibilityFailure = createAction(
  getActionName('Load Start Eligibility Failure', monthEndActionPrefix),
  props<{ error: string }>(),
);
